import { getDay } from 'date-fns/esm'

interface Props {
  index: number
  values: Date[]
  selected: boolean
  dayNumber: ReturnType<typeof getDay>
  dateFnsOptions: uui.domain.DateFnsOptions
}

/**
 * Computes the value of the rounded border for a single day on calendar
 */
export function getRoundedBorder(props: Props): 'left' | 'right' | 'none' {
  const { index, values, selected, dayNumber, dateFnsOptions } = props

  const lastOfRow = (dateFnsOptions.weekStartsOn + 6) % 7 === dayNumber
  const firstOfRow = dayNumber === dateFnsOptions.weekStartsOn
  const lastDayToRender = index === values.length - 1
  const firstDayToRender = index === 0

  return selected && (firstOfRow || firstDayToRender)
    ? 'left'
    : selected && (lastOfRow || lastDayToRender)
      ? 'right'
      : 'none'
}
